<template>
  <div>
    <!-- <button class="logout" @click="onLogout()">logout</button> -->
    <header>
      <div class="ef--inner first">
        <h1>
          <img src="/assets/images/common/logo.png" alt="きゅうでん電気予報">
        </h1>
        <div class="admin">
          <span>{{username}}さま</span>
          <a href="javascript:void(0);" @click="onLogout()">ログアウト</a>
        </div>
      </div>
      <nav>
        <div class="ef--inner">
          <div class="nav-area">
            <ul>
              <li>
                <a href="javascript:void(0);" @click="$router.push('/admin')">
                  <img src="/assets/images/common/menu.icon1.png">
                  <span>HOME</span>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" @click="$router.push('/admin/accountlist')">
                  <img src="/assets/images/common/admin_menu.icon2.png">
                  <span>アカウント管理</span>
                </a>
              </li>
              <li v-if="this.$store.state.loginType != 3">
                <a href="javascript:void(0);" @click="$router.push('/admin/news/edit')">
                  <img src="/assets/images/common/admin_menu.icon3.png">
                  <span>お知らせ更新</span>
                </a>
              </li>
              <li class="li-bottom">
                <a href="javascript:void(0);" @click="$router.push('/admin/controller')">
                  <img src="/assets/images/common/admin_menu.icon5.png">
                  <span>制御</span>
                </a>
              </li>
              <li class="li-bottom">
                <a href="javascript:void(0);" @click="$router.push('/admin/multi_circuit_graph_list')">
                  <img src="/assets/images/common/menu.icon7.png">
                  <span>グラフ</span>
                </a>
              </li>
              <li class="li-bottom">
                <a href="javascript:void(0);" @click="$router.push('/admin/system_setting')">
                  <img src="/assets/images/common/admin_menu.icon4.png">
                  <span>システム設定</span>
                </a>
              </li>
              <li class="li-bottom">
                <a href="javascript:void(0);" @click="$router.push('/admin/troubleshooting_history')">
                  <img src="/assets/images/common/admin_menu.icon6.png">
                  <span>トラブル対応履歴</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="panel">
            <div class="menu-trigger">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </nav>
    </header>
    <router-view/>
    <footer>
      <div class="ef--inner">
        <p>Copyright (c) KYUSHU ELECTRIC POWER CO., INC. All Rights Reserved.</p>
      </div>
    </footer>
    <Loading v-if="isLoading"/>
  </div>
</template>

<script>
import Loading from './Loading.vue'
export default {
  name: "admin",
  components: { Loading },
  computed: {
    username() {
      return this.$store.state.loginID;
    },
    isLoading() {
      return this.$store.state.isLoading
    }
  },
  mounted: function() {
    /* sp panel */
    $(".panel").on("click", function() {
      // console.log('admin:panel_click');
      
      $(".menu-trigger, header nav").toggleClass("active");
      $("nav .nav-area").slideToggle();
      $(".overlay").fadeToggle("slow");
    });
    $(".overlay").on("click", function() {
      $(".overlay, nav .nav-area").fadeToggle("slow");
      $(".menu-trigger, header nav").removeClass("active");
    });
  },
  methods: {
    /* eslint-disable no-console */
    /* eslint-disable no-unused-vars */
    onLogout: function() {
      console.log("logout");
      const self = this;
      const params = new URLSearchParams();
      this.$store.dispatch("logout");
      this.$store.commit("RESET");
      this.$axios
        .post(`/srv/api/logout`, params, {
          withCredentials: true
        })
        .then(response => {
          const data = response.data;
          // console.log(data);
          if (data.status !== undefined) {
            if (data.status === "success") {
              console.log("success");
              self.$router.push("/login");
            } else {
              console.log("error");
              self.$router.push("/login");
            }
          } else {
            console.log("error");
            self.$router.push("/login");
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
/* body {
  font-size: 14px;
  font-size: 1.0rem;
  font-weight: 500;
  line-height: 1.6;
  position: relative;
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -o-text-size-adjust: 100%;
  text-size-adjust: 100%;
  text-align: left;
  width: 100%;
  color: #4e4d4d;
} */
header nav ul li {
  width: 170px;
}
header nav ul li a {
  font-size: 13px;
}
</style>
